import { ProductReview } from "@interfaces/dto/products.dto";

export const MockupProductReviews: ProductReview[] = [
  {
    id: 1,
    review_date: "20 - 10 - 2021",
    review_time: "19:30",
    reviewer_name: "Lo*****rem",
    reviewer_img: "/assets/images/icon-account-circle-red.png",
    review_text: `Lorem ipsum dolor sit amet, consectetur adipiscing elit,`,
    rating_score: 3,
    review_img: ["/assets/images/product-7.jpg", "/assets/images/product-6.jpg", "/assets/images/product-5.jpg", "/assets/images/product-7.jpg", "/assets/images/product-6.jpg"],
    review_like: 20,
    review_unlike: 6,
  },
  {
    id: 2,
    review_date: "21 - 10 - 2021",
    review_time: "19:30",
    reviewer_name: "สม*****าย",
    reviewer_img: "/assets/images/icon-account-circle.png",
    review_text: `At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis`,
    rating_score: 5,
    review_img: ["/assets/images/product-7.jpg", "/assets/images/product-6.jpg", "/assets/images/product-5.jpg", "/assets/images/product-7.jpg", "/assets/images/product-6.jpg"],
    review_like: 3,
    review_unlike: 0,
  },
  {
    id: 3,
    review_date: "22 - 10 - 2021",
    review_time: "19:30",
    reviewer_name: "ชนา*****ร",
    reviewer_img: "/assets/images/icon-account-circle-black.png",
    review_text: `through weakness of will, which is the same as saying through shrinking from toil and pain. These cases are perfectly simple and easy to distinguish. In a free hour, when our power of choice is untrammelled and when nothing prevents our being able to do what we like best, every pleasure is to be welcomed and eve`,
    rating_score: 5,
    review_img: ["/assets/images/product-7.jpg", "/assets/images/product-6.jpg"],
    review_like: 3,
    review_unlike: 7,
  },
  {
    id: 4,
    review_date: "23 - 10 - 2021",
    review_time: "19:30",
    reviewer_name: "สุ*****",
    reviewer_img: "/assets/images/icon-account-circle-red.png",
    review_text: `welcomed and every pain avoided. But in certain circumstances and owing to the claims of duty or the obligations of business it will frequently occur that pleasures have to be repudiated and annoyances accepted. The wise man therefore always holds in these matters to this principle`,
    rating_score: 5,
    review_img: ["/assets/images/product-7.jpg"],
    review_like: 2,
    review_unlike: 1,
  },
]